export const DestinationFr: { [key: string]: string } = {
  1: '1 - Unité de soins de courte durée',
  2: '2 - Unité de soins de suite et de réadaptation',
  3: '3 - Unité de soins de longue durée',
  4: '4 - Psychiatrie',
  5: '5 - Service d\'urgence',
  6: '6 - Hospitalisation à domicile',
  7: '7 - Structure d\'hébergement médico-sociale',
}

export const OriginFr: { [key: string]: string } = {
  ...DestinationFr,
  R: 'R - Réanimation',
  U: 'U - Urgences d\'une autre entité géographique',
  V: 'V - Passage par une structure des urgences d\'une autre entité géographique et par celle de l\'entité géographique de l\'établissement (UHCD comprises)',
}

const OriginAndDestinationCh: { [key: number]: string } = {
  1: '01 - Domicile',
  6: '06 - Autre hôpital (soins aigus) ou maison de naissance',
  7: '07 - Institution d\'exécution des peines',
  8: '08 - Autre',
  66: '66 - Division/clinique de soins aigus, même établissement',
  9: '09 - Inconnu',
}

export const OriginCh: { [key: number]: string } = {
  ...OriginAndDestinationCh,
  2: '02 - Domicile avec soins à domicile',
  3: '03 - Etablissement de santé non hospitalier médicalisé',
  4: '04 - Etablissement de santé non hospitalier non médicalisé',
  5: '05 - Clinique psychiatrique, autre établissement',
  55: '55 - Division/clinique psychiatrique, même établissement',
  83: '83 - Clinique de réadaptation, autre établissement',
  84: '84 - Clinique de réadaptation, même établissement',
}

export const DestinationCh: { [key: number]: string } = {
  ...OriginAndDestinationCh,
  0: '00 - Décédé',
  2: '02 - Etabl. de santé non hospit. médicalisé',
  3: '03 - Id. non médicalisé',
  4: '04 - Institution psychiatrique, autre établissement',
  5: '05 - Institution de réadaptation, autre établissement',
  44: '44 - Division/clinique psychiatrique, même établissement',
  55: '55 - Division/clinique de réadaptation, même établissement',
}
